import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export default function SessionExpiredDialog({
  open,
  reason = "Your session has expired. Please log in again.",
  onClose,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-description"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
          m: 2,
          textAlign: "center",
          maxWidth: "400px",
          margin: "auto",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <DialogTitle id="session-expired-title">Session Expired</DialogTitle>

      <DialogContent>
        <Typography variant="body1" id="session-expired-description">
          {reason}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={onClose} autoFocus variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
